@if (filterSearchTable && !loading){
    <div class="button-bar ral">
        <app-cf-filter
            class="short-typehead"
            [placeholderTextDefault]="'Filter on anything here'"
            [placeholderTextActive]="'You need 3 characters minimum to start searching'"
            [isSearching]="isFilteringInProgress"
            (lookup)="filter($event)">  
        </app-cf-filter>
        <app-cf-button [enabled]="!loading" [type]="applicationButtonType" (click)="getCAutoApplicants()">CAuto Applicants</app-cf-button>
        <app-cf-button [enabled]="!loading" [type]="cautoAbeonaUserButtonType" (click)="getCAutoAbeonaUsers()">CAuto Abeona Users</app-cf-button>
    </div>
    
    <app-cf-table [data]="filterSearchTable" [sortable]="true" (onButtonClicked)="rowButtonClicked($event)"></app-cf-table>
}
@else{
    <app-cf-loader [size]="loaderSize"><p>Please wait while we apply requested changes...</p></app-cf-loader>
}    